import { ArrowLeft } from 'lucide-react'

import { Money } from '@/components/ds'
import { Button } from '@/components/ui/button'
import { Sku } from '@/interfaces/catalog/Sku'

import { ProductTile } from './ProductTile'
import { variantLabel } from './registerUtils'

interface SkuSelectionViewProps {
  productName: string
  skus: Sku[]
  onSkuClick: (sku: Sku) => void
  onBack: () => void
  getAvailableToAdd: (skuId: string) => number
  quantityInTicket: (skuId: string) => number
}

/** Výběr varianty produktu, nahrazuje mřížku produktů dokud se nevybere. */
export function SkuSelectionView({
  productName,
  skus,
  onSkuClick,
  onBack,
  getAvailableToAdd,
  quantityInTicket,
}: SkuSelectionViewProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex shrink-0 items-center gap-3 pb-4">
        <Button variant="ghost" className="-ml-2 h-11 px-3 text-foreground" onClick={onBack}>
          <ArrowLeft />
          Zpět
        </Button>
        <div className="min-w-0">
          <p className="truncate text-base font-semibold tracking-[-0.01em]">{productName}</p>
          <p className="text-xs text-muted-foreground">Vyberte variantu</p>
        </div>
      </div>
      <div className="-m-1 min-h-0 flex-1 overflow-y-auto p-1">
        <div className="grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-3">
          {skus.map((sku) => {
            const available = getAvailableToAdd(sku.id)
            return (
              <ProductTile
                key={sku.id}
                name={variantLabel(sku, productName)}
                meta={sku.code}
                price={
                  sku.price?.price?.amount ? (
                    <Money amount={sku.price.price.amount} currency={sku.price.price.currency} size="sm" />
                  ) : null
                }
                available={available}
                inTicket={quantityInTicket(sku.id)}
                onClick={() => onSkuClick(sku)}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
